import { observable } from "mobx";
import CameraType from "./cameraType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class CameraResponse {
  id!: string;

  @observable
  externalCameraIdent!: number;

  @observable
  type!: CameraType;

  @observable
  segment!: string;

  @observable
  name!: string;

  @observable
  isEnabled!: boolean;

  @observable
  isDeleted!: boolean;
}
